export const message = {
  userAccountSuccess: 'Account successfully updated'
}